import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export const IsTabletWidth = (): boolean => {
	return useMediaQuery('(max-width:1024px)');
};

export const IsMd = (): boolean => {
	const theme = useTheme();
	return useMediaQuery(theme.breakpoints.up('md'));
};

export const IsMobileWidth = (): boolean => {
	return useMediaQuery('(max-width:600px)');
};
